<template>
  <section class="cluster-statistics statistics">
    <Breadcrumbs
      :breadcrumbs="[
        { title: $t('menu.statistics'), disabled: true },
        { title: $t('menu.clusterstatistics'), disabled: true }
      ]">
    </Breadcrumbs>

    <form class="evollu-form">

      <div class="row" v-if="clusters.length">
        <div class="col-12 col-sm-5">
          <va-switch v-model="filters.showEntityStats">
            <span slot="trueTitle">{{$t('kiosks.entity')}}</span>
            <span slot="falseTitle">
              <span>
                {{$t('statistics.cluster')}}
              </span>
              <span v-if="!filters.showEntityStats && filters.cluster" @click.prevent="expandCluster = !expandCluster" class="cluster-dropdown">
                <i class="fa" :class="{'fa-chevron-up': expandCluster, 'fa-chevron-down': !expandCluster}"></i>
              </span>
            </span>
          </va-switch>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-5">
          <span v-if="filters.showEntityStats">
            <label class="form-label">{{$t('statistics.select_entity')}}:</label>
            <multiselect
              id="entities-multiselect"
              v-model="filters.entity"
              :options="entityOptions"
              track-by="id"
              :custom-label="formatedEntityLabel"
              :placeholder="!entityOptions.length ? $t('statistics.no_entities') : $t('statistics.totalValues')"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
              :disabled="entityOptions.length < 2"
            >
              <span slot="noResult">{{$t('patients.noResults')}}</span>
              <template slot="clear" slot-scope="props" v-if="entityOptions.length > 1 && filters.entity !== null">
                <div id="entities-multiselect-clear" class="multiselect__clear" @mousedown.prevent.stop="filters.entity = null"></div>
              </template>
            </multiselect>
          </span>

          <span v-else>
            <label class="form-label">{{$t('statistics.select_cluster')}}:</label>
            <multiselect
              id="clusters-multiselect"
              v-model="filters.cluster"
              :options="clusterOptions"
              track-by="id"
              :custom-label="formatedEntityLabel"
              :placeholder="!clusterOptions.length ? $t('statistics.no_clusters') : $t('statistics.totalValues')"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
              :disabled="clusterOptions.length < 2"
            >
              <span slot="noResult">{{$t('patients.noResults')}}</span>
              <template slot="clear" slot-scope="props" v-if="clusterOptions.length > 1 && filters.cluster !== null">
                <div id="clusters-multiselect-clear" class="multiselect__clear" @mousedown.prevent.stop="filters.cluster = null"></div>
              </template>
            </multiselect>
          </span>
        </div>

        <div class="col-12 col-sm-3">
          <label class="form-label">{{$t('statistics.date_field')}}:</label>
          <multiselect
            v-model="filters.dateType"
            :options="dateOptions"
            select-label=""
            deselect-label="×"
            placeholder="---"
            :allow-empty="false"
            :multiple="false"
            :searchable="true"
            :disabled="isLoading"
          >
            <span slot="noResult">{{$t('patients.noResults')}}</span>
            <template slot="singleLabel" slot-scope="props">
              <span class="option__name">{{ $t(`statistics.${props.option}` )}}</span>
            </template>
            <template slot="option" slot-scope="props">
              <span class="option__name">{{ $t(`statistics.${props.option}`) }}</span>
            </template>
          </multiselect>
        </div>

        <div class="col-12 col-sm-4">
          <RangeDatePicker
            id="range-date-picker"
            :label="`${$t('statistics.date_interval')}:`"
            v-model="filters.dateRange"
            placeholder="---"
            :clearable="false"
            :disabled="isLoading"
          >
          </RangeDatePicker>
        </div>
      </div>

      <div v-if="!filters.showEntityStats && filters.cluster && expandCluster" class="row mb-5">
        <div class="col-12">
          <va-badge outline v-for="(name, index) in filters.cluster.entity_names" :key="index">
            {{name}}
          </va-badge>
        </div>
      </div>
    </form>

    <div v-show="isLoading" class="no-data-wrapper">
      <h6><b>{{$t('tables.loading')}}</b></h6>
      <LoadingAnimation :size="'5px'" class="d-flex justify-content-center pt-4 pb-4"></LoadingAnimation>
    </div>

    <div v-show="!isLoading && !entityOptions.length" class="no-data-wrapper">
      <span class="is-bold">{{$t('statistics.no_data_for_date_interval')}}</span>
    </div>

    <div v-show="!isLoading && entityOptions.length" class="row cluster-stats-content">
      <div class="section" :class="{'col-sm-6 col-xl-4': !sidebarMinimized, 'col-sm-6 col-xl-4 col-xxl-5ths': sidebarMinimized}">
        <h5 class="section-title">{{ $t('statistics.registos') }}</h5>
        <div class="row">
          <div class="col-sm-6 half-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ counterEntries + kioskEntries + cancelledCount + appEntries + webEntries}}
                  </div>
                  <div class="text-center">
                    <va-popover
                      placement="bottom"
                      :message="$t('statistics.registos_tooltip')">
                      {{$t('statistics.registos')}}
                      <i class="fa fa-info-circle"></i>
                    </va-popover>
                  </div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-6 half-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ sessionEntries }}
                  </div>
                  <div class="text-center">
                    <va-popover
                      placement="bottom"
                      :message="$t('statistics.registos_rastreio_tooltip')">
                      {{$t('statistics.registos_rastreio')}}
                      <i class="fa fa-info-circle"></i>
                    </va-popover>
                  </div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-3 small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ kioskEntries }}
                  </div>
                  <div class="text-center">
                    <va-popover
                      placement="bottom"
                      :message="$t('statistics.kiosk_registers')">
                      {{$t('statistics.kiosk')}}<br>
                      <i class="fa fa-info-circle" style="margin-top: 3px;"></i>
                    </va-popover>
                  </div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-3 small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ counterEntries }}
                  </div>
                  <!-- <div class="text-center">{{$t('statistics.balcony_registers')}}</div> -->
                  <div class="text-center">{{$t('statistics.counter_registers')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-3 small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ appEntries }}
                  </div>
                  <div class="text-center">{{$t('statistics.app_registers')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-3 small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ webEntries }}
                  </div>
                  <div class="text-center">{{$t('statistics.web_registers')}}</div>
                </div>
              </div>
            </va-card>
          </div>

        </div>
        <div class="row">
          <div class="col-12 chart-widget-wrapper">
            <va-card class="chart-widget">
              <va-chart
                :data="kiosksData"
                :options="chartOptions"
                type="donut"
              >
              </va-chart>
            </va-card>
          </div>
        </div>
      </div>
      <div class="section" :class="{'col-sm-6 col-xl-4': !sidebarMinimized, 'col-sm-6 col-xl-4 col-xxl-5ths': sidebarMinimized }">
        <h5 class="section-title">{{ $t('kiosks.graph.tests') }}</h5>
        <div class="row">
          <div class="col-sm-6 half-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ ht }}
                  </div>
                  <div class="text-center">{{$t('statistics.tests')}}</div>
                </div>
              </div>
            </va-card>
          </div>
          <div class="col-sm-6 half-stats cancelled-status">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ cancelledHtLoss + cancelledHtNoLoss }}
                  </div>
                  <div class="text-center">{{$t('statistics.cancelled_tests')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-3 small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ htLoss }}
                  </div>
                  <div
                    class="text-center"
                  >{{$t('statistics.graph_label_test_with_hearing_loss')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-3 final-status small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ htNoLoss }}
                  </div>
                  <div
                    class="text-center"
                  >{{$t('statistics.graph_label_test_without_hearing_loss')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-3 cancelled-status small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ cancelledHtLoss }}
                  </div>
                  <div
                    class="text-center"
                  >{{$t('statistics.graph_label_test_with_hearing_loss')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-3 cancelled-status small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ cancelledHtNoLoss }}
                  </div>
                  <div
                    class="text-center"
                  >{{$t('statistics.graph_label_test_without_hearing_loss')}}</div>
                </div>
              </div>
            </va-card>
          </div>
        </div>
        <div class="row">
          <div class="col-12 chart-widget-wrapper">
            <va-card class="chart-widget"><!-- :title="$t('kiosks.graph.tests')">-->
              <va-chart
                :data="cancelledData"
                :options="chartOptions"
                type="donut"
              ></va-chart>
            </va-card>
          </div>
        </div>
      </div>
      <div class="section" :class="{'col-sm-6 col-xl-4': !sidebarMinimized, 'col-sm-6 col-xl-4 col-xxl-5ths': sidebarMinimized }">
        <h5 class="section-title">{{ $t('statistics.contacts') }}</h5>
        <div class="row">
          <div class="col-sm-6 half-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ scheduledAppointments }}
                  </div>
                  <div class="text-center">
                    <va-popover
                      placement="bottom"
                      :message="$t('statistics.consultations_go_tooltip')">
                      {{$t('statistics.consultations_go')}}
                      <i class="fa fa-info-circle"></i>
                    </va-popover>
                  </div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-6 half-stats final-status-success">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ contactsSuccessCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.11')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-3 small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ contactsPostponedCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.12')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-3 small-stats final-status">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ contactsNoSuccessCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.10')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-3 small-stats final-status-success">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ contactsSuccessNoHLCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.graph_label_test_without_hearing_loss')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-3 small-stats final-status">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ contactsSuccessHLCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.graph_label_test_with_hearing_loss')}}</div>
                </div>
              </div>
            </va-card>
          </div>
        </div>
        <div class="row">
          <div class="col-12 chart-widget-wrapper">
            <va-card class="chart-widget"><!-- :title="$t('statistics.contacts')">-->
              <va-chart
                :data="contactsData"
                :options="chartOptions"
                type="donut"
              ></va-chart>
            </va-card>
          </div>
        </div>
      </div>
      <div class="section" :class="{'col-sm-6 col-xl-6': !sidebarMinimized, 'col-sm-6 col-xl-6 col-xxl-5ths': sidebarMinimized }">
        <h5 class="section-title">{{ $t('statistics.consultations') }}</h5>
        <div class="row">
          <div class="col-sm-6 half-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ convertedToAppointmentCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.100')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-6 half-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ totalAppointments }}
                  </div>
                  <div class="text-center">
                    <va-popover
                      placement="bottom"
                      :message="$t('statistics.consultations_made_tooltip')">
                      {{$t('statistics.consultations_made')}}
                      <i class="fa fa-info-circle"></i>
                    </va-popover>
                  </div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-3 small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ appointmentMissedCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.105')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-3 final-status small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ appointmentNotApplicableCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.101')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-3 final-status small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ appointmentNoSaleCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.102')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-3 final-status-success small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ appointmentEntCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.106')}}</div>
                </div>
              </div>
            </va-card>
          </div>

        </div>
        <div class="row">
          <div class="col-12 chart-widget-wrapper">
            <va-card class="chart-widget"> <!-- :title="$t('statistics.consultations')"> -->
              <va-chart
                :data="appointmentsData"
                :options="chartOptions"
                type="donut"
              ></va-chart>
            </va-card>
          </div>
        </div>
      </div>
      <div class="section" :class="{'col-sm-6 col-xl-6': !sidebarMinimized, 'col-sm-6 half-stats col-xl-6 col-xxl-5ths': sidebarMinimized }">
        <h5 class="section-title">{{ $t('statistics.sales') }}</h5>
        <div class="row">
          <div class="col-sm-6 half-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ appointmentPossibleSaleCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.103')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-6 half-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ trialCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.104')}}</div>
                  <!-- <div class="text-center">{{$t('statistics.contacts_postponed')}}</div> -->
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-6 half-stats final-status-success">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ buysCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.110')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <!-- <div class="col-sm-6 half-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ consultationsWithLoss }}
                  </div>
                  <div class="text-center">{{$t('statistics.consultations_loss')}}</div>
                </div>
              </div>
            </va-card>
          </div> -->

          <div class="col-sm-6 half-stats ">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ qualifiedCount }}
                  </div>
                  <div class="text-center">
                    <va-popover
                      placement="bottom"
                      :message="$t('statistics.qualified_leads_tooltip')">
                      {{$t('pyramid.lqe')}}
                      <i class="fa fa-info-circle"></i>
                    </va-popover>
                  </div>
                </div>
              </div>
            </va-card>
          </div>

        </div>
        <div class="row">
          <div class="col-12 chart-widget-wrapper">
            <va-card class="chart-widget"><!-- :title="$t('statistics.sales')"> -->
              <va-chart
                :data="salesData"
                :options="chartOptions"
                type="donut"
              ></va-chart>
            </va-card>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import { StatisticsService } from '@/api/LeadsService'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import { FULL_STATS } from '@/local-storage/LocalStorageKeys'
import RangeDatePicker from '@/components/common/RangeDatePicker'
import LocalStorageHelper from '@/local-storage/LocalStorageHelper'
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter'
import LoadingAnimation from '@/components/users/components/Helpers/LoadingAnimation'

export default {
  components: {
    Multiselect,
    Breadcrumbs,
    RangeDatePicker,
    LoadingAnimation
  },
  mixins: [
    MultiselectLabelFormatter
  ],
  data () {
    return {
      chartOptions: {
        cutoutPercentage: 70,
        legend: {
          position: 'bottom',
          labels: {
            fontColor: this.$store.getters.fontColor,
            fontFamily: 'sans-serif',
            fontSize: 14,
            padding: 20,
            usePointStyle: true
          }
        },
        tooltips: {
          bodyFontSize: 14,
          bodyFontFamily: 'sans-serif'
        },
        responsive: true,
        maintainAspectRatio: false
      },
      expandCluster: false,
      isLoading: false,
      dataset: [],
      totalValues: null,
      dateOptions: [
        'created_at',
        'updated_at',
        'qualified_at',
        'sale_at'
      ],
      filters: {
        showEntityStats: true,
        entity: null,
        cluster: null,
        dateRange: {
          start: this.moment().subtract(1, 'months').format('YYYY-MM-DD'),
          end: this.moment().format('YYYY-MM-DD')
        },
        dateType: 'created_at'
      }
    }
  },
  methods: {
    loadBaseData () {
      if(!this.isLoading) {
        this.isLoading = true
        StatisticsService.getFullStats(this.requestParams)
          .then(originalData => this.createDataset(originalData))
          .catch((error) => {
            console.log(error)
            this.showToast(this.$t('statistics.something_went_wrong'), this.$store.state.errorToastOptions)
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    createDataset: function (data) {
      this.dataset = {}
      this.totalValues = null

      if (data.length) {
        data
          .sort((a, b) => a.id - b.id)
          .forEach(element => {
            this.dataset[element.id] = this.createDatasetEntry(element)
          })

        this.totalValues = this.calculateAggregateData(Object.keys(this.dataset))
      }
    },
    calculateAggregateData: function (entityIds) {
      let aggregate = this.createDatasetEntry()
      const keys = Object.keys(aggregate)

      entityIds.forEach(entityId => {
        if (this.dataset.hasOwnProperty(entityId)) {
          keys.forEach(key => {
            aggregate[key] += this.dataset[entityId][key]
          })
        }
      })

      return aggregate
    },
    createDatasetEntry: function (data = {}) {
      return {
        counter: 0,
        kiosk: 0,
        app: 0,
        web: 0,
        kiosk_ht: 0,
        kiosk_ht_loss: 0,
        questionnaires: 0,
        contacts_no_success: 0,
        contacts_success: 0,
        contacts_success_hl: 0,
        contacts_postponed: 0,
        requested_appointment: 0,
        converted_to_appointment: 0,
        appointment_not_applicable: 0,
        appointment_no_sale: 0,
        appointment_possible_sale: 0,
        trial: 0,
        qualified: 0,
        appointment_missed: 0,
        appointment_ent: 0,
        sale: 0,
        cancelled: 0,
        cancelled_ht_loss: 0,
        cancelled_ht_no_loss: 0,
        sessions: 0,
        leads_sessions: 0,
        ...data
      }
    },
    getFullEntityById: function (id) {
      return this.fullEntities.find(e => e.id === id)
    },
    loadLocalStorage: function () {
      return new Promise((resolve, reject) => {
        const state = LocalStorageHelper.get(FULL_STATS)
        if (state !== null) {
          this.filters = {
            ...this.filters,
            ...state
          }
        }
        resolve()
      })
    }
  },
  computed: {
    ...mapGetters([
      'sidebarMinimized',
      'clusters'
    ]),
    audiologyService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.evollead_server)
    },
    fullEntities: function () {
      return this.audiologyService ? this.audiologyService.entities : []
    },
    requestParams: function () {
      return {
        from: this.filters.dateRange.start,
        until: this.filters.dateRange.end,
        date: this.filters.dateType
      }
    },
    entityOptions: function () {
      return Object.values(this.dataset)
        .map(element => {
          let entity = this.getFullEntityById(element.id)
          return {
            id: element.id,
            name: element.name,
            cities: entity ? entity.cities : []
          }
        })
    },
    clusterOptions: function () {
      return this.clusters
        .map(cluster => {
          let entitiesWithPermissions = this.entityOptions.filter(entity => cluster.entitiesIds.some(entityId => entity.id === entityId))
          cluster.entitiesWithPermissions = entitiesWithPermissions.length
          cluster.entity_names = entitiesWithPermissions.map(e => e.name)
          return cluster
        })
        .filter(cluster => cluster.entitiesWithPermissions > 0)
    },
    stats: function () {
      if (this.filters.showEntityStats && this.filters.entity) {
        return this.dataset[this.filters.entity.id]
      } else if (!this.filters.showEntityStats && this.filters.cluster) {
        return this.calculateAggregateData(this.filters.cluster.entitiesIds)
      } else {
        return this.totalValues
      }
    },
    baseKiosksValues: function () {
      if (this.stats) {
        return [
          this.stats.kiosk_ht,
          this.stats.questionnaires - this.stats.kiosk_ht,
          this.stats.kiosk - this.stats.questionnaires,
          this.stats.counter
        ]
      }
      return [0, 0, 0, 0]
    },
    kiosksData () {
      return {
        labels: [
          this.$t('statistics.graph_label_test'),
          this.$t('statistics.graph_label_questionary'),
          this.$t('statistics.graph_label_contact_requested'),
          this.$t('statistics.graph_label_counter')
        ],
        datasets: [{
          data: this.baseKiosksValues,
          backgroundColor: [
            '#5dceb3',
            '#a4d8cc',
            '#a3afaf',
            '#d8dcdc'
          ]
        }]
      }
    },
    baseContactsValues: function () {
      if (this.stats) {
        return [
          this.stats.converted_to_appointment,
          this.stats.contacts_success,
          this.stats.contacts_postponed,
          this.stats.contacts_no_success
        ]
      }
      return [0, 0, 0, 0]
    },
    contactsData () {
      return {
        labels: [
          this.$t('statistics.graph_label_appointment'),
          this.$t('statistics.status.11'),
          this.$t('statistics.graph_label_contact_later'),
          this.$t('statistics.status.10')
        ],
        datasets: [{
          data: this.baseContactsValues,
          backgroundColor: [
            '#5dceb3',
            '#a4d8cc',
            '#a3afaf',
            '#d8dcdc'
          ]
        }]
      }
    },
    baseAppointmentsValues: function () {
      if (this.stats) {
        return [
          this.stats.appointment_ent,
          this.stats.appointment_no_sale,
          this.stats.appointment_not_applicable
        ]
      }
      return [0, 0, 0]
    },
    appointmentsData () {
      return {
        labels: [
          this.$t('statistics.status.106'),
          this.$t('statistics.status.102'),
          this.$t('statistics.status.101')
        ],
        datasets: [{
          data: this.baseAppointmentsValues,
          backgroundColor: [
            '#5dceb3',
            '#a4d8cc',
            '#d8dcdc'
          ]
        }]
      }
    },
    baseSalesValues: function () {
      if (this.stats) {
        return [
          this.stats.appointment_possible_sale,
          this.stats.trial,
          this.stats.sale,
        ]
      }
      return [0, 0, 0]
    },
    salesData: function () {
      return {
        labels: [
          this.$t('statistics.status.103'),
          this.$t('statistics.status.104'),
          this.$t('statistics.status.110')
        ],
        datasets: [{
          data: this.baseSalesValues,
          backgroundColor: [
            '#d8dcdc',
            '#a4d8cc',
            '#5dceb3'
          ]
        }]
      }
    },
    baseCancelledValues: function () {
      if (this.stats) {
        return [
          this.stats.kiosk_ht_loss,
          this.stats.cancelled_ht_loss,
          this.stats.kiosk_ht - this.stats.kiosk_ht_loss,
          this.stats.cancelled_ht_no_loss
        ]
      }
      return [0, 0, 0, 0]
    },
    cancelledData () {
      return {
        labels: [
          this.$t('statistics.tests_loss'),
          this.$t('statistics.cancelled_tests_loss'),
          this.$t('statistics.tests_no_loss'),
          this.$t('statistics.cancelled_tests_no_loss')
        ],
        datasets: [{
          data: this.baseCancelledValues,
          backgroundColor: [
            '#5dceb3',
            '#a4d8cc',
            '#a3afaf',
            '#d8dcdc'
          ]
        }]
      }
    },
    counterEntries: function () {
      return this.stats ? this.stats.counter : 0
    },
    kioskEntries: function () {
      return this.stats ? this.stats.kiosk : 0
    },
    appEntries: function () {
      return this.stats ? this.stats.app : 0
    },
    webEntries: function () {
      return this.stats ? this.stats.web : 0
    },
    ht: function () {
      return this.stats ? this.stats.kiosk_ht : 0
    },
    htLoss: function () {
      return this.stats ? this.stats.kiosk_ht_loss : 0
    },
    htNoLoss: function () {
      return this.stats ? (this.stats.kiosk_ht - this.stats.kiosk_ht_loss) : 0
    },
    contactsCount: function () {
      return this.stats ? (this.stats.contacts_no_success + this.stats.contacts_success + this.stats.contacts_postponed) : 0
    },
    contactsSuccessCount: function () {
      return this.stats ? this.stats.contacts_success : 0
    },
    contactsSuccessHLCount: function () {
      return this.stats ? this.stats.contacts_success_hl : 0
    },
    contactsSuccessNoHLCount: function () {
      return this.stats ? (this.stats.contacts_success - this.stats.contacts_success_hl) : 0
    },
    totalSuccessContacts: function () {
      return this.contactsSuccessCount + this.scheduledAppointments
    },
    contactsNoSuccessCount: function () {
      return this.stats ? this.stats.contacts_no_success : 0
    },
    contactsPostponedCount: function () {
      return this.stats ? this.stats.contacts_postponed : 0
    },
    convertedToAppointmentCount: function () {
      return this.stats ? this.stats.converted_to_appointment : 0
    },
    scheduledAppointments: function () {
      return this.convertedToAppointmentCount + this.totalAppointments + this.appointmentMissedCount
    },
    appointmentNotApplicableCount: function () {
      return this.stats ? this.stats.appointment_not_applicable : 0
    },
    appointmentNoSaleCount: function () {
      return this.stats ? this.stats.appointment_no_sale : 0
    },
    appointmentPossibleSaleCount: function () {
      return this.stats ? this.stats.appointment_possible_sale : 0
    },
    appointmentMissedCount: function () {
      return this.stats ? this.stats.appointment_missed : 0
    },
    appointmentEntCount: function () {
      return this.stats ? this.stats.appointment_ent : 0
    },
    totalAppointments: function () {
      return this.appointmentPossibleSaleCount +
            this.appointmentEntCount +
            this.appointmentNotApplicableCount +
            this.appointmentNoSaleCount +
            this.trialCount + this.buysCount
    },
    trialCount: function () {
      return this.stats ? this.stats.trial : 0
    },
    buysCount: function () {
      return this.stats ? this.stats.sale : 0
    },
    qualifiedCount: function () {
      return this.stats ? this.stats.qualified : 0
    },
    cancelledCount: function () {
      return this.stats ? this.stats.cancelled : 0
    },
    cancelledHtLoss: function () {
      return this.stats ? this.stats.cancelled_ht_loss : 0
    },
    cancelledHtNoLoss: function () {
      return this.stats ? this.stats.cancelled_ht_no_loss : 0
    },
    sessionEntries: function () {
      return this.stats ? this.stats.leads_sessions : 0
    },
    consultationsWithLoss: function () {
      return this.qualifiedCount + this.appointmentEntCount
    }
  },
  watch: {
    entityOptions: {
      handler: function (options) {
        if (options.length === 1) {
          this.filters.entity = options[0]
        } else if (this.filters.entity && !options.some(option => option.id === this.filters.entity.id)) {
          this.filters.entity = null
        }
      },
      immediate: true
    },
    clusterOptions: {
      handler: function (options) {
        // Multiselect did not update label unless v-model was reset to null and then set again
        const previousValue = this.filters.cluster
        this.filters.cluster = null
        let newSelectedValue = null

        if (options.length === 1) {
          newSelectedValue = options[0]
        } else if (previousValue) {
          newSelectedValue = options.find(option => option.id === previousValue.id) || null
        }

        this.$nextTick(() => {
          this.filters.cluster = newSelectedValue
        })
      },
      immediate: true
    },
    filters: {
      handler: function () {
        LocalStorageHelper.set(FULL_STATS, this.filters)
      },
      deep: true
    },
    'filters.showEntityStats': function (value) {
      if (!value && !this.clusters.length) {
        this.filters.showEntityStats = true
      }
    },
    requestParams: function (value) {
      this.loadBaseData()
    }
  },
  mounted () {
    this.loadLocalStorage()
      .then(() => {
        this.loadBaseData()
      })
  }
}
</script>

<style lang="scss">

.cluster-stats-content {

  .half-stats, .small-stats, .chart-widget-wrapper {
    padding-left: 0.35rem;
    padding-right: 0.35rem;
  }

  .va-card__body {
    overflow-x: unset;
  }

  .info-widget-inner {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    min-height: 100px !important;

    &.has-chart {
      justify-content: space-between;
    }

    .stats {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      height: 100%;
      min-height: 100px;
    }
  }
}

.stats-number {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 2.25rem;
  margin-bottom: 0.5rem;
  margin-top: 12px;

  &.small-number {
    font-size: 1.5rem;
    margin-top: 16px;
  }

  @media (min-width: 1600px) {
    &.small-number {
      font-size: 1.5rem;
    }
  }

  .stats-icon {
    font-size: 1.5625rem;
    position: absolute;
    top: 0.625rem;
    left: -1.25rem;

    &.icon-wide {
      left: -1.875rem;
    }
  }
}

.final-status .va-card {
  background: #d8dcdc;
}

.cancelled-status .va-card {
  background: #d8dcdc;
  color: #7d8888;
}

.final-status-success .va-card {
  background: #5dceb3;
}
</style>
